"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castIntrinsic = function (value) {
    // boolean early return
    if (value == 'true')
        return true;
    if (value == 'false')
        return false;
    var charCode0 = value.charCodeAt(0);
    var charCode1 = value.charCodeAt(1);
    // .[0-9] or if it starts with [0-9]
    if (value[0] == '.' && charCode1 >= 48 && charCode1 <= 57 || charCode0 >= 48 && charCode0 <= 57) {
        return Number(value);
    }
    return value; // string
};
//# sourceMappingURL=cast-intrinsic.js.map